export default __webpack_public_path__ + "static/media/devchallenges-light.e890e049.svg";